import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "section section--projects" }
const _hoisted_3 = {
  key: 0,
  class: "empty"
}
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = {
  key: 2,
  class: "projects"
}

import { computed } from "vue";
import { GET_ACTIVE_PROJECTS } from "@/graphql/project/queries";
import enUK from "@/locales/project/en-UK.json";
import { useI18n } from "vue-i18n";
import { ProjectRoutes } from "@/router/projectRoutes";
import usePaginatedQuery from "@/composables/usePaginatedQuery";
import ProjectCard from "@/components/ProjectCard.vue";

type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsList',
  props: {
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const variables = computed(() => ({
  active: props.active,
}));

const { paginatedResult: projectsResult, loading } = usePaginatedQuery(
  GET_ACTIVE_PROJECTS,
  t("errors.list"),
  variables,
);

const projects = computed(() => {
  return projectsResult.value?.items || [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("project.loading")), 1))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.error.message), 1))
          : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
                return (_openBlock(), _createBlock(ProjectCard, {
                  tag: "li",
                  onClick: ($event: any) => (
            _ctx.$router.push({
              name: _unref(ProjectRoutes).PROJECT_ROOT,
              params: { id: project.id },
            })
          ),
                  class: "project",
                  key: project.id,
                  title: project.name,
                  project: project
                }, null, 8, ["onClick", "title", "project"]))
              }), 128))
            ]))
    ])
  ]))
}
}

})